// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../HBuilderX/plugins/uniapp-cli/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\"\n/* 颜色变量 */\n/** S Font's size **/\n/** E Font's size **/\n/* 颜色变量 */\n/** S Font's size **/\n/** E Font's size **/", ""]);
// Exports
exports.locals = {
	"red_theme": "#ff2c3c",
	"orange_theme": "#f7971e",
	"pink_theme": "#fa444d",
	"gold_theme": "#e0a356",
	"blue_theme": "#2f80ed",
	"green_theme": "#2ec840"
};
module.exports = exports;
